import React, { useEffect, useState } from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Footer from "./global-components/footer";
import Apartment from "./section-components/apartment-v1";
import { useParams } from "react-router";
import Gallery from "./section-components/gallery-v1";

const Service_Details = () => {
  let publicUrl = process.env.PUBLIC_URL + "/";

  let list = [
    {
      id: 101,
      name: "Home Automation",
      logo: publicUrl + "assets/img/icons/icon-img/21.png",
      subCategory: [
        {
          title: "Lighting",
          SubTitle: "Lighting",
          Description:
            "Home automation for lighting enables you to control the lighting in your home from anywhere, at any time. You can set schedules to turn lights on and off at specific times, or even control the brightness and color of your lights to suit different moods or activities.\n" +
            "One of the biggest advantages of home automation for lighting is that it can significantly reduce energy consumption and save money on utility bills. With the ability to control lighting remotely, you can ensure that lights are turned off when not in use, or automatically dimmed during daylight hours to take advantage of natural light.\n" +
            "Additionally, home automation for lighting can improve home security by allowing you to turn lights on and off while away from home. This can create the impression that someone is home, which can deter potential intruders.\n" +
            "Overall, home automation for lighting provides greater convenience, energy efficiency, and security to homeowners. It is a valuable investment that can enhance the functionality and comfort of any home.",
          images: publicUrl + "assets/img/service-details/s1_lighting.png",
          videoUrl: publicUrl + "assets/media/lighting_video.mp4",
          galleryImages: [
            {
              image: publicUrl + "assets/img/service-details/s1_lighting.png",
            },
            {
              image: publicUrl + "assets/img/service-details/light_2.png",
            },
            {
              image: publicUrl + "assets/img/service-details/light_3.png",
            },
          ],
          video: true,
        },
        {
          title: "Curtains",
          SubTitle: "Curtains",
          Description:
            "Home automation for curtains offers several benefits to homeowners, including convenience, energy efficiency, and enhanced home security. With automated curtains, you can schedule the opening and closing of your curtains based on your daily routine or preferences. You can also remotely control the curtains using your smartphone or voice assistant, which means you can adjust them without leaving your seat.\n" +
            "Another advantage of home automation for curtains is energy efficiency. By setting up schedules for opening and closing the curtains, you can take advantage of natural light and reduce the need for artificial lighting. This can help save on energy costs and reduce your carbon footprint.\n" +
            "Home automation for curtains can also enhance home security by giving the impression that someone is at home even when the house is empty. By setting up a schedule for your curtains to open and close at specific times, you can create the impression that someone is home, which can deter potential intruders.\n" +
            "Overall, home automation for curtains offers a convenient, energy-efficient, and secure way to control the curtains or blinds in your home. It is a valuable investment that can enhance the functionality and comfort of any home.",
          images: publicUrl + "assets/img/service-details/s1_curtains.png",
          videoUrl: publicUrl + "assets/media/curtains.mp4",
          galleryImages: [],
          video: true,
        },
        // {
        //   title: "AC/TV",
        //   SubTitle: "AC/TV",
        //   Description:
        //     "There are Different types of lighting options. We can ON / OFF the lighting through different types of controls.",
        //   images: publicUrl + "assets/img/service-details/s1_ac_tv.png",
        //   video: false
        // },
        {
          title: "Control Media",
          SubTitle: "Control Media",
          Description:
            "With home automation for controlling media, you can use various devices such as remote controls, smartphones, or voice assistants to control your media devices. This means you can easily switch between different devices, select media, adjust volume, and even pause or rewind content without leaving your seat.\n" +
            "One of the biggest advantages of home automation for controlling media is convenience. By using a single remote control or smartphone app, you can control multiple media devices in your home, eliminating the need for multiple remotes and reducing clutter.\n" +
            "Home automation for controlling media can also enhance the entertainment experience in your home. By automating your home theater, you can create a more immersive experience by controlling the lighting, temperature, and even curtains, all from a single device.\n" +
            "Another advantage of home automation for controlling media is that it can be integrated with other smart home devices. For example, you can use your voice assistant to control your media devices or even integrate your media devices with your lighting system to create a more immersive experience.\n" +
            "Overall, home automation for controlling media provides greater convenience, comfort, and entertainment to homeowners. It is a valuable investment that can enhance the functionality and enjoyment of any home.",
          images: publicUrl + "assets/img/service-details/control_media_2.png",
          galleryImages: [
            {
              image:
                publicUrl + "assets/img/service-details/control_media_1.png",
            },
            {
              image:
                publicUrl + "assets/img/service-details/control_media_3.png",
            },
            {
              image: publicUrl + "assets/img/service-details/s1_ac_tv.png",
            },
            {
              image:
                publicUrl + "assets/img/service-details/control_media_4.png",
            },
            {
              image: publicUrl + "assets/img/service-details/ac_automation.png",
            },
          ],
          video: false,
        },
        {
          title: "Smart Door Lock",
          SubTitle: "Smart Door Lock System",
          Description:
            "Home automation for door locks offers several benefits to homeowners, including convenience, security, and peace of mind. With automated door locks, you can remotely control the locking and unlocking of your doors, eliminating the need for keys or physical contact with the lock.\n" +
            "Another advantage of home automation for door locks is enhanced security. By using keyless entry systems, you can eliminate the risk of lost or stolen keys, which can be used by unauthorized individuals to gain access to your home. You can also set up schedules for the locking and unlocking of doors, or even receive notifications when someone enters or exits your home, providing greater visibility and control.\n" +
            "Home automation for door locks can also provide peace of mind, especially when away from home. With remote access and control, you can ensure that your doors are locked even when you are not physically present, and you can also grant temporary access to guests or service providers.\n" +
            "Overall, home automation for door locks provides greater convenience, security, and peace of mind to homeowners. It is a valuable investment that can enhance the safety and functionality of any home.",
          images: publicUrl + "assets/img/service-details/door-lock/2.jpg",
          galleryImages: [
            {
              image: publicUrl + "assets/img/service-details/door-lock/1.jpg",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/5.png",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/3.png",
            },
            {
              image:
                publicUrl + "assets/img/service-details/smart_door_lock.png",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/4.jpg",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/6.png",
            },
          ],
        },
        {
          title: "Video Door Access",
          SubTitle: "Video Door Access",
          Description:
            "Home automation for door camera access offers several benefits to homeowners, including increased security, convenience, and peace of mind. With a door camera system, you can see who is at your door before deciding to answer it or not. You can also set up alerts that notify you when someone approaches your door, or even receive video recordings of any activity at your door.\n" +
            "Another advantage of home automation for door camera access is convenience. With remote access, you can view and monitor your door camera from anywhere using your smartphone or tablet. This means you can easily check who is at your door without having to physically go to the door.\n" +
            "Home automation for door camera access can also provide peace of mind, especially when away from home. With remote access and monitoring, you can ensure that your home is safe and secure, and you can also grant temporary access to guests or service providers while you are away.\n" +
            "Overall, home automation for door camera access provides greater security, convenience, and peace of mind to homeowners. It is a valuable investment that can enhance the safety and functionality of any home.",
          images:
            publicUrl +
            "assets/img/service-details/smart_door_access_camera.png",
          galleryImages: [
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/4.png",
            },
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/2.jpg",
            },
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/3.jpg",
            },
          ],
          video: false,
        },
      ],
    },
    {
      id: 102,
      name: "Audio Video",
      logo: publicUrl + "assets/img/icons/icon-img/22.png",
      subCategory: [
        {
          title: "Multi Room Audio System",
          SubTitle: "Multi Room Audio System",
          Description:
            "Multi Room Audio Systems offer several benefits to homeowners, including the ability to enjoy music or audio content throughout their home, without the need for multiple audio systems in each room. With a central audio source, homeowners can access and control their audio content from a single location, and can play different audio content in different rooms, or the same content throughout the entire building.\n" +
            "Multi Room Audio Systems also provide flexibility and customization, allowing homeowners to tailor their audio experience to their preferences. They can choose to have speakers in every room, or only in select rooms, and can even choose different speaker types and configurations for different rooms.\n" +
            "Multi Room Audio Systems can also be integrated with other smart home devices, allowing for seamless control and automation. For example, the audio system can be integrated with lighting and temperature control systems to create a more immersive audiovisual experience.\n" +
            "Overall, a Multi Room Audio System is a valuable investment for homeowners who want to enhance their audio experience throughout their home. It provides convenience, flexibility, customization, and can be integrated with other smart home devices to create a more seamless and immersive audiovisual experience.",
          images:
            publicUrl + "assets/img/service-details/s2_multi_room_audio.png",
          video: false,
          galleryImages: [],
        },
        {
          title: "PA Solution",
          SubTitle: "PA Solution",
          Description:
            "A Media Solution typically consists of software, hardware, and network components that work together to provide a seamless media experience. It can include media servers, media players, streaming devices, and content management systems, as well as integration with other smart home devices such as smart TVs and home automation systems.\n" +
            "The benefits of a Media Solution are numerous. It allows users to easily organize and access their media content from any device, anywhere, and at any time. It also provides a seamless and immersive media experience, with high-quality video and audio, and customizable settings such as subtitles and audio tracks.\n" +
            "A Media Solution can also be integrated with other smart home devices, allowing for greater automation and control. For example, users can use their voice or a smart device to control their media playback, adjust the volume, or even dim the lights to create a more immersive media experience.\n" +
            "Overall, a Media Solution is a valuable investment for anyone who wants to enjoy their media content in a seamless, convenient, and immersive way. It provides a comprehensive system for managing and accessing media content, as well as integration with other smart home devices to create a more automated and personalized media experience.",
          images: publicUrl + "assets/img/service-details/pa_main.png",
          galleryImages: [],
          video: false,
        },
      ],
    },
    {
      id: 103,
      name: "ELV Solution",
      logo: publicUrl + "assets/img/icons/icon-img/23.png",
      subCategory: [
        {
          title: "CCTV",
          SubTitle: "CCTV",
          Description:
            "CCTV systems for ELV solutions are designed to provide greater security and situational awareness, and to help deter crime and other unauthorized activities. These systems can include a variety of different cameras and recording devices, such as fixed or pan-tilt-zoom cameras, digital video recorders, and network video recorders.\n" +
            "In addition to traditional CCTV systems, many modern ELV solutions allow for mobile integration of CCTV. This means that users can access and monitor CCTV feeds from their mobile devices, such as smartphones or tablets. This can provide greater flexibility and convenience for users, allowing them to monitor activities remotely and respond quickly to any security concerns.\n" +
            "Mobile integration of CCTV systems for ELV solutions can be achieved through various methods, such as dedicated mobile applications or web-based portals. These systems can provide users with real-time access to CCTV feeds, as well as the ability to review footage and customize alerts and notifications.\n" +
            "The benefits of mobile integration of CCTV systems for ELV solutions are numerous. They provide users with greater flexibility and convenience, allowing them to monitor activities from anywhere at any time. They also provide a powerful deterrent against criminal activity, and can help identify and track suspects in the event of a crime.\n" +
            "Overall, CCTV systems for ELV solutions, including mobile integration, are an important aspect of building security and operations. They provide a powerful and flexible tool for monitoring and recording activities, and can be integrated with other ELV systems for a more comprehensive and effective solution.",
          images: publicUrl + "assets/img/service-details/cctv/1.jpg",
          videoUrl: publicUrl + "assets/media/cctv_video.mp4",

          galleryImages: [
            {
              image: publicUrl + "assets/img/service-details/cctv/2.png",
            },
            {
              image: publicUrl + "assets/img/service-details/cctv/3.png",
            },
            {
              image: publicUrl + "assets/img/service-details/cctv/4.png",
            },
            {
              image: publicUrl + "assets/img/service-details/cctv/5.png",

            },
          ],
          video: true,
        },
        {
          title: "Intrusion System",
          SubTitle: "Intrusion System",
          Description:
            "Fire solutions for ELV systems are designed to detect and respond to fires in a timely manner, and to provide early warning to building occupants, emergency responders, and other stakeholders. These systems typically include fire alarms, smoke detectors, heat detectors, and other sensors that detect the presence of smoke or fire.\n" +
            "When a fire is detected, the fire solutions for ELV systems can activate various automated responses, such as shutting down power or air conditioning systems, closing fire doors, or activating fire suppression systems, such as sprinklers or foam systems. These responses can help contain the fire and prevent it from spreading, while also alerting building occupants and emergency responders to the situation.\n" +
            "Fire solutions for ELV systems can also integrate with other ELV systems, such as access control, CCTV, and public address systems, to provide greater situational awareness and control. For example, the fire system can trigger CCTV cameras to capture footage of the fire, or activate public address systems to provide evacuation instructions to building occupants.\n" +
            "Overall, fire solutions for ELV systems are an important aspect of building safety and security. They provide early detection and response to fires, while also integrating with other ELV systems to create a more comprehensive and effective fire solution.",
          images: publicUrl + "assets/img/service-details/intrusion/main_1.png",
          galleryImages: [],
          video: false,
        },
      ],
    },
    {
      id: 104,
      name: "Security",
      logo: publicUrl + "assets/img/icons/icon-img/21.png",
      subCategory: [
        {
          title: "Access Control",
          SubTitle: "Access Control",
          Description:
            "Home automation for door locks offers several benefits to homeowners, including convenience, security, and peace of mind. With automated door locks, you can remotely control the locking and unlocking of your doors, eliminating the need for keys or physical contact with the lock.\n" +
            "Another advantage of home automation for door locks is enhanced security. By using keyless entry systems, you can eliminate the risk of lost or stolen keys, which can be used by unauthorized individuals to gain access to your home. You can also set up schedules for the locking and unlocking of doors, or even receive notifications when someone enters or exits your home, providing greater visibility and control.\n" +
            "Home automation for door locks can also provide peace of mind, especially when away from home. With remote access and control, you can ensure that your doors are locked even when you are not physically present, and you can also grant temporary access to guests or service providers.\n" +
            "Overall, home automation for door locks provides greater convenience, security, and peace of mind to homeowners. It is a valuable investment that can enhance the safety and functionality of any home.",
          images: publicUrl + "assets/img/service-details/door-lock/2.jpg",
          galleryImages: [
            {
              image: publicUrl + "assets/img/service-details/door-lock/1.jpg",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/5.png",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/3.png",
            },
            {
              image:
                publicUrl + "assets/img/service-details/smart_door_lock.png",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/4.jpg",
            },
            {
              image: publicUrl + "assets/img/service-details/door-lock/6.png",
            },
          ],
        },

        {
          title: "Smart Door Lock",
          SubTitle: "Smart Door Lock",
          Description:
            "Home automation for door camera access offers several benefits to homeowners, including increased security, convenience, and peace of mind. With a door camera system, you can see who is at your door before deciding to answer it or not. You can also set up alerts that notify you when someone approaches your door, or even receive video recordings of any activity at your door.\n" +
            "Another advantage of home automation for door camera access is convenience. With remote access, you can view and monitor your door camera from anywhere using your smartphone or tablet. This means you can easily check who is at your door without having to physically go to the door.\n" +
            "Home automation for door camera access can also provide peace of mind, especially when away from home. With remote access and monitoring, you can ensure that your home is safe and secure, and you can also grant temporary access to guests or service providers while you are away.\n" +
            "Overall, home automation for door camera access provides greater security, convenience, and peace of mind to homeowners. It is a valuable investment that can enhance the safety and functionality of any home.",
          images:
            publicUrl +
            "assets/img/service-details/smart_door_access_camera.png",
          galleryImages: [
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/4.png",
            },
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/2.jpg",
            },
            {
              image:
                publicUrl +
                "assets/img/service-details/door-camera-access/3.jpg",
            },
          ],
          video: false,
        },
      ],
    },
    {
      id: 105,
      name: "IT Racks & Networking",
      logo: publicUrl + "assets/img/icons/icon-img/22.png",
      subCategory: [
        {
          title: "Rack Installation",
          SubTitle: "Rack Installations",
          Description:
            "The process of rack installation typically involves selecting an appropriate rack size and configuration for the equipment being housed, as well as ensuring that the rack is installed in a suitable location with adequate power and cooling. This may involve running power and data cabling to the rack, as well as configuring network switches and other networking equipment.\n" +
            "During the rack installation process, it is important to ensure that all equipment is properly secured and organized, with cables properly managed to avoid tangling and to ensure proper airflow. This can help prevent equipment failures and ensure that the IT infrastructure is running at peak performance.\n" +
            "In addition to physical rack installation, IT professionals may also need to configure and manage network settings, security protocols, and access controls for the IT infrastructure housed within the rack. This may involve implementing firewalls, setting up virtual private networks (VPNs), and monitoring network traffic to ensure that the IT infrastructure is secure and functioning properly.\n" +
            "Overall, rack installation is a critical component of IT infrastructure management, and requires careful planning and execution to ensure that equipment is properly housed, organized, and secured. With the right system in place, IT professionals can ensure that their IT infrastructure is running at peak performance, and that data and systems are protected from security threats and other vulnerabilities.",
          images:
            publicUrl + "assets/img/service-details/rack-networking/1.jpeg",
          video: false,
          galleryImages: [],
        },
        {
          title: "Networking",
          SubTitle: "Networking",
          Description:
            "Networking for IT racks typically involves the deployment and configuration of network switches, routers, and other networking equipment to connect servers, storage devices, and other IT equipment within the rack. This may involve configuring VLANs, network security protocols, and other settings to ensure that the network is secure and optimized for performance.\n" +
            "In addition to physical networking equipment, IT professionals may also need to configure and manage virtual networks, such as virtual private networks (VPNs), to enable remote access to IT resources housed within the rack. This may involve configuring network protocols and security settings, as well as managing access controls and authentication processes to ensure that only authorized users can access the network.\n" +
            "Another important aspect of networking for IT racks is monitoring and troubleshooting. IT professionals must be able to monitor network traffic and performance to identify and address any issues or vulnerabilities that may arise, such as bottlenecks or security breaches. This may involve configuring network monitoring tools and other software to help diagnose and resolve network issues.\n" +
            "Overall, networking is a critical component of IT infrastructure management, and requires careful planning, configuration, and ongoing management to ensure that the network is secure, optimized for performance, and able to support the needs of the organization. With the right system in place, IT professionals can ensure that their IT infrastructure is running at peak performance, and that data and systems are protected from security threats and other vulnerabilities.",
          images:
            publicUrl + "assets/img/service-details/rack-networking/2.png",
          video: false,
          galleryImages: [],
        },
        {
          title: "FireWall Security",
          SubTitle: "FireWall Security",
          Description:
            "Essentially, Firewall Security is all about keeping your network and infrastructure safe from unauthorized access, malware, and other security threats. This is achieved through the use of specialized devices or software that filter incoming and outgoing network traffic based on predefined rules and policies.\n" +
            "Firewalls act as a barrier between your network and the outside world, allowing authorized traffic to pass through while blocking anything that looks suspicious. This not only prevents unauthorized access to your network, but also helps to stop the spread of malware and other security threats.\n" +
            "To achieve optimal Firewall Security for IT Racks & Networking, it's important to configure your firewall devices or software to block incoming traffic from certain IP addresses, ports, or protocols, or to allow traffic only from authorized users or devices. Additionally, monitoring network traffic for suspicious activity can help you to detect and respond to security threats before they can cause serious damage.\n" +
            "Ultimately, Firewall Security is a critical component of any IT infrastructure management plan, and requires careful planning, configuration, and ongoing management to ensure that your network is fully protected from security threats and vulnerabilities. So, if you're looking to keep your IT infrastructure running smoothly and securely, Firewall Security is definitely an area to focus on.",
          images: publicUrl + "assets/img/service-details/firewall_main.png",
          video: false,
          galleryImages: [],
        },
      ],
    },
    {
      id: 106,
      name: "Cinema Solution",
      logo: publicUrl + "assets/img/icons/icon-img/23.png",
      subCategory: [
        {
          title: "Cinema",
          SubTitle: "Cinema",
          Description:
            "Our cinema solutions are designed to provide the ultimate viewing and listening experience. We work with you to create a customized solution that meets your specific needs and preferences. This includes selecting the right sound system for your space, whether you want a basic 5.1 setup or a more advanced 12.1 system.\n" +
            "Our sound systems are designed to deliver a high-quality audio experience, with crystal-clear sound and powerful bass. We use state-of-the-art equipment and the latest technologies to ensure that your cinema experience is as immersive as possible.\n" +
            "In addition to sound systems, we also offer a range of other cinema solutions, including high-quality projectors, screens, seating, and lighting. We can work with you to design a complete cinema experience that meets your needs and fits your budget.\n" +
            "Overall, our cinema solutions are designed to provide you with a high-quality, immersive entertainment experience in the comfort of your own home. Whether you want a basic setup or a more advanced system, we can help you create the perfect cinema experience for your needs.",
          images: publicUrl + "assets/img/service-details/cinema/1.jpg",
          video: false,
          galleryImages: [],
        },
      ],
    },
  ];

  const { id } = useParams();

  const [value, setValue] = useState([]);

  useEffect(() => {
    console.log("ID: ", id);
    console.log("list", list.length);
    for (var i = 0; i < list.length; i++) {
      console.log("list", list[i].id);
      if (list[i].id.toString() === id) {
        console.log("list", list[i]);
        setValue(list[i]);
      }
    }
  }, [id]);

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Service Details" subheader="Service Details" />
      {/* <ServiceDetails />
        <CallToActionV1 /> */}
      <div style={{ marginTop: "115px" }}>
        <Apartment value={value} />
      </div>
      <Footer />
    </div>
  );
};

export default Service_Details;
